import { observer } from 'mobx-react';
import industry from '../../model/industry_data.json';
import { forwardRef, Fragment, useImperativeHandle, useState } from 'react';
import {
    Highlighter,
    Menu,
    MenuItem,
    Typeahead
} from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import classNames from 'classnames';
import * as style from './KnowledgeBaseTagging.module.less';
import { Flex } from '../UI/Flex/Flex';
import {
    IndustryTagSelect,
    IndustryTag,
    TaggingStore
} from '../IndustryTagSelect/IndustryTagSelect';
import { Button } from 'react-bootstrap';
import { observable } from 'mobx';

export interface KnowledgeBaseRefAPI {
    loadTags: (tagged: IndustryTag[]) => void;
    getTags(): IndustryTag[];
}

export const KnowledgeBaseTagging = observer(
    forwardRef<KnowledgeBaseRefAPI, {}>((props, ref) => {
        const [tagStore] = useState(new TaggingStore());

        useImperativeHandle(
            ref,
            () => ({
                loadTags: (tagged: []) => {
                    tagStore.taggedIds = tagged;
                },
                getTags: () => {
                    return tagStore.taggedIds;
                }
            }),
            []
        );

        return (
            <Flex
                wrap="wrap"
                justify="start"
                className="w-100"
                style={{ gap: '20px', padding: '20px' }}
            >
                <div
                    className="w-100"
                    style={{ fontSize: '20px', fontWeight: '600' }}
                >
                    Tag Editor
                </div>
                <div className="w-100" style={{ height: '300px' }}>
                    <IndustryTagSelect
                        tagStore={tagStore}
                        allowSelectAll={true}
                    />
                </div>
                <div className="w-100"></div>
            </Flex>
        );
    })
);
